'use client'

// src/components/form/socialRedirect.ts
var AUTH_PAGE = /\/(login|signup|reset-password)(\/|$)/;
var getSocialRedirect = (search, pathname) => {
  const redirect = search.get("redirect");
  if (redirect) return redirect;
  if (AUTH_PAGE.test(pathname)) return null;
  const query = search.toString();
  return pathname + (query ? `?${query}` : "");
};

export {
  getSocialRedirect
};
//# sourceMappingURL=chunk-5KLY43LU.mjs.map